import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import parse from 'html-react-parser';

const useStyles = makeStyles((theme) => ({
  // This has to vary for multiple buttons on the same page, for example.
  // In this case class will be non-deterministic, e.g. 'jss-1'
  IncBtn: {
    color: props => props.txtColor ?? props.txtColor,
  },
  // This is common for all, so we can have standard CSS class.
  '@global': {
    '.featured': {},
  },
}));

function ButtonsRow(props) {
  let {node, block} = props;
  node = (!node && block) ? block : node;

  let {btnOpts, btnStyle, ctaLinks} = node;
  const classes = useStyles(node);

  let btnAlign = btnOpts?.first.toLowerCase() == 'right' ? 'flex-end' : (btnOpts?.first.toLowerCase() == 'left' ? 'flex-start' : 'center');

  return (
    <Box display={`flex`}>
      <Grid container justifyContent={btnAlign} spacing={4}>
        {ctaLinks?.map((btn, index) => (
          <Grid item key={`btn-i-${index}`}>
            <Button disableElevation variant="contained" className={(btnOpts?.second) ? classes.FeatBtn : ''}
                    size={btnStyle.second} color={btnStyle.first}
                    href={btn.second}>{parse(btn.first)}</Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ButtonsRow;
